{
  "comment": "M7 spec §1 rule 7, §4–§8, §8.3, §16.6 (S11 owns the content; src/story/callbacks.ts runs it): one echo and 1–2 callbacks per story flag, plus the ladder, commit and reactivation triggers. flag = a STORY_FLAG or a STORY_TRIGGER (src/story/types.ts); delayDays in online faction days, a number or [min, max] (a seeded pick); condition = a CALLBACK_CONDITIONS id, checked when it fires; channel wire (posted with its outlet source and severity 1..3) | comms (a one-line hail; speaker named) | log (a texture record, never evidence: no log, lead or proof, T33). Trigger texts may use {station} and {family}; flag texts use none. Names, dates and codes are placeholders until the naming pass (spec §15 item 7).",
  "callbacks": [
    {
      "id": "echo.manifest_recovered",
      "kind": "echo",
      "flag": "manifest_recovered",
      "delayDays": 1,
      "condition": "manifestDecoded",
      "channel": "wire",
      "source": "mutualBulletin",
      "text": "Salvager turns up First Rush convoy wreck in the deep. Recorder decoded at the Mutual yard; the yard isn't saying what it read.",
      "severity": 1
    },
    {
      "id": "cb.manifest_recovered.1",
      "kind": "callback",
      "flag": "manifest_recovered",
      "delayDays": [10, 20],
      "condition": "manifestDecoded",
      "channel": "wire",
      "source": "candleRelay",
      "text": "Beacons set at the convoy field. Seven hulls, still in line. Families have started going out from the Harrow to read the names.",
      "severity": 1
    },
    {
      "id": "echo.manifest_sold",
      "kind": "echo",
      "flag": "manifest_sold",
      "delayDays": 1,
      "channel": "wire",
      "source": "tethysComms",
      "text": "Tethys Asset Recovery returns company property from a deep-field wreck. \"Old hulls, old paper. We look after both,\" a spokesperson said.",
      "severity": 1
    },
    {
      "id": "cb.manifest_sold.1",
      "kind": "callback",
      "flag": "manifest_sold",
      "delayDays": [15, 30],
      "channel": "comms",
      "speaker": "assetRecovery",
      "text": "Asset Recovery, on your bow. Yellow KT-3, cream band. We've met. You sold us a recorder once, fair price, no questions. If you find another, the price is the same. The questions aren't."
    },
    {
      "id": "cb.manifest_sold.2",
      "kind": "callback",
      "flag": "manifest_sold",
      "delayDays": [5, 10],
      "channel": "wire",
      "source": "mutualBulletin",
      "text": "Convoy field in the deep stripped to frames. Mutual crews report Tethys tugs worked it five days. Nothing left to tow.",
      "severity": 1
    },
    {
      "id": "echo.watchers_helped",
      "kind": "echo",
      "flag": "watchers_helped",
      "delayDays": 1,
      "condition": "belowTier3",
      "channel": "wire",
      "source": "mutualBulletin",
      "text": "Raiders hit a Tethys barge at the vein. Two crew to the pod. One not.",
      "severity": 2
    },
    {
      "id": "echo.watchers_helped.guardians",
      "kind": "echo",
      "flag": "watchers_helped",
      "delayDays": 1,
      "condition": "tier3",
      "channel": "wire",
      "source": "authorityGazette",
      "text": "Guardians hit a Tethys barge at the vein. Two crew to the pod. One not.",
      "severity": 2
    },
    {
      "id": "cb.watchers_helped.1",
      "kind": "callback",
      "flag": "watchers_helped",
      "delayDays": [10, 20],
      "condition": "reyesAlive",
      "channel": "comms",
      "speaker": "reyes",
      "text": "The barge wreck's still out there. Salvagers took the plating. Nobody took the names off the hull. I checked."
    },
    {
      "id": "echo.watchers_stood_off",
      "kind": "echo",
      "flag": "watchers_stood_off",
      "delayDays": 1,
      "channel": "wire",
      "source": "mutualBulletin",
      "text": "Raiders hit a Tethys barge at the vein. Witnesses report an independent ship holding station at range throughout.",
      "severity": 2
    },
    {
      "id": "cb.watchers_stood_off.1",
      "kind": "callback",
      "flag": "watchers_stood_off",
      "delayDays": [10, 20],
      "channel": "comms",
      "speaker": "kell",
      "text": "Reyes says you watched. She's not angry. She wrote you down as weather."
    },
    {
      "id": "echo.watchers_betrayed",
      "kind": "echo",
      "flag": "watchers_betrayed",
      "delayDays": 1,
      "channel": "wire",
      "source": "tethysComms",
      "text": "Tethys crew escape ambush after tip-off. \"An independent pilot did the right thing,\" said Tethys security.",
      "severity": 2
    },
    {
      "id": "cb.watchers_betrayed.1",
      "kind": "callback",
      "flag": "watchers_betrayed",
      "delayDays": [15, 30],
      "channel": "log",
      "text": "GUARDIAN WRECK · nav core, last page\nDo not trust: lease hull, KT-3, yellow, cream band. Called the barge.\nUnderlined twice. Under it, another hand: \"Two of ours.\""
    },
    {
      "id": "cb.watchers_betrayed.2",
      "kind": "callback",
      "flag": "watchers_betrayed",
      "delayDays": [5, 10],
      "channel": "comms",
      "speaker": "kell",
      "text": "The board at the Candle has a hull on it now. Yours. I'd stay off the Harrow for a while."
    },
    {
      "id": "echo.hale_logged_route",
      "kind": "echo",
      "flag": "hale_logged_route",
      "delayDays": 1,
      "channel": "wire",
      "source": "authorityGazette",
      "text": "Charter Patrol reports routine courier inspections on the Senn lanes. Traffic waved through.",
      "severity": 1
    },
    {
      "id": "cb.hale_logged_route.1",
      "kind": "callback",
      "flag": "hale_logged_route",
      "delayDays": [10, 20],
      "channel": "comms",
      "speaker": "recordsDesk",
      "text": "Records desk. Your route filings from the Senn run were requested by the Commissioner's office. Routine. We tell everyone it's routine."
    },
    {
      "id": "echo.report_original",
      "kind": "echo",
      "flag": "report_original",
      "delayDays": 1,
      "channel": "wire",
      "source": "mutualBulletin",
      "text": "Old Tethys research derelict at the Carrow belt shows fresh tool marks on bay four. Nobody has filed for the salvage.",
      "severity": 1
    },
    {
      "id": "cb.report_original.1",
      "kind": "callback",
      "flag": "report_original",
      "delayDays": [10, 20],
      "condition": "okaforFree",
      "channel": "comms",
      "speaker": "okafor",
      "text": "You've read it now. Read the withdrawn lines again. The blanks are where I stopped."
    },
    {
      "id": "echo.okafor_public",
      "kind": "echo",
      "flag": "okafor_public",
      "delayDays": 1,
      "channel": "wire",
      "source": "tethysComms",
      "text": "Tethys notes \"unverified claims\" by former survey staff. Dr I. Okafor left company service in CY8.",
      "severity": 2
    },
    {
      "id": "cb.okafor_public.1",
      "kind": "callback",
      "flag": "okafor_public",
      "delayDays": [10, 20],
      "condition": "okaforFree",
      "channel": "comms",
      "speaker": "okafor",
      "text": "They'll ask me about the drafts at a hearing. I've started writing down what I'll say. It's shorter than I thought it would be."
    },
    {
      "id": "echo.okafor_anonymous",
      "kind": "echo",
      "flag": "okafor_anonymous",
      "delayDays": 1,
      "channel": "wire",
      "source": "mutualBulletin",
      "text": "A former Tethys survey hand has given a statement to an independent pilot. The Mutual won't name him.",
      "severity": 1
    },
    {
      "id": "cb.okafor_anonymous.1",
      "kind": "callback",
      "flag": "okafor_anonymous",
      "delayDays": [10, 20],
      "condition": "okaforFree",
      "channel": "comms",
      "speaker": "okafor",
      "text": "Thank you for leaving my name off it. I've been sleeping. That's new."
    },
    {
      "id": "echo.hale_aware",
      "kind": "echo",
      "flag": "hale_aware",
      "delayDays": 1,
      "channel": "wire",
      "source": "authorityGazette",
      "text": "Charter Patrol inspection logs a sealed core aboard an independent hull. \"Within normal parameters.\"",
      "severity": 1
    },
    {
      "id": "cb.hale_aware.1",
      "kind": "callback",
      "flag": "hale_aware",
      "delayDays": [5, 10],
      "channel": "comms",
      "speaker": "recordsDesk",
      "text": "Records desk. A copy of your inspection log went up to the Commissioner's office this morning. I wasn't asked to tell you."
    },
    {
      "id": "echo.okafor_warned",
      "kind": "echo",
      "flag": "okafor_warned",
      "delayDays": 1,
      "condition": "okaforHideout",
      "channel": "comms",
      "speaker": "okafor",
      "text": "I've seen the survey ships. I'm not leaving my relay for a rumour. Come and get me if you're coming."
    },
    {
      "id": "cb.okafor_warned.1",
      "kind": "callback",
      "flag": "okafor_warned",
      "delayDays": [3, 5],
      "condition": "okaforHideout",
      "channel": "comms",
      "speaker": "kell",
      "text": "The old man's packed a bag. He hasn't left. Says he's waiting for you."
    },
    {
      "id": "echo.voss_contacted",
      "kind": "echo",
      "flag": "voss_contacted",
      "delayDays": 1,
      "channel": "log",
      "text": "COMMS LOG · inbound · Tethys executive channel\nDuration 4 min 12 s. Not recorded at source. Closed by the caller."
    },
    {
      "id": "cb.voss_contacted.1",
      "kind": "callback",
      "flag": "voss_contacted",
      "delayDays": [10, 20],
      "channel": "wire",
      "source": "tethysComms",
      "text": "Voss at the Carrow ring: \"Four thousand families ate on what got through that gate before it shut. I'd make the same calls.\"",
      "severity": 1
    },
    {
      "id": "echo.archive_legal",
      "kind": "echo",
      "flag": "archive_legal",
      "delayDays": 1,
      "channel": "wire",
      "source": "authorityGazette",
      "text": "Sealed archive access granted to an independent pilot under the Records Act. Fee paid in full.",
      "severity": 1
    },
    {
      "id": "cb.archive_legal.1",
      "kind": "callback",
      "flag": "archive_legal",
      "delayDays": [5, 10],
      "channel": "comms",
      "speaker": "recordsDesk",
      "text": "Records desk. Your access request is in the Commissioner's weekly digest. Everything is in the digest."
    },
    {
      "id": "echo.archive_back",
      "kind": "echo",
      "flag": "archive_back",
      "delayDays": 1,
      "channel": "wire",
      "source": "mutualBulletin",
      "text": "Mutual relay crew completes its maintenance slot at the seat. No faults found.",
      "severity": 1
    },
    {
      "id": "cb.archive_back.1",
      "kind": "callback",
      "flag": "archive_back",
      "delayDays": [15, 30],
      "condition": "haleKnows",
      "channel": "wire",
      "source": "mutualBulletin",
      "text": "Charter Office audits the Mutual relay crew's maintenance slots. Crew stood down pending review.",
      "severity": 2
    },
    {
      "id": "cb.archive_back.2",
      "kind": "callback",
      "flag": "archive_back",
      "delayDays": [10, 20],
      "condition": "haleUnaware",
      "channel": "comms",
      "speaker": "mutualRelayCrew",
      "text": "Relay crew. Nobody's asked about the sixth-day slot. Let's keep it that way."
    },
    {
      "id": "echo.settlement_file",
      "kind": "echo",
      "flag": "settlement_file",
      "delayDays": 1,
      "channel": "wire",
      "source": "authorityGazette",
      "text": "Registry: Settlement entry 50-A marked \"withdrawn\".",
      "severity": 1
    },
    {
      "id": "cb.settlement_file.1",
      "kind": "callback",
      "flag": "settlement_file",
      "delayDays": [10, 20],
      "condition": "duarteHidden",
      "channel": "comms",
      "speaker": "duarte",
      "text": "The 50-A shelf has a new label. \"Withdrawn.\" Nobody withdrew it. I file the labels."
    },
    {
      "id": "echo.hale_deal",
      "kind": "echo",
      "flag": "hale_deal",
      "delayDays": 1,
      "channel": "wire",
      "source": "authorityGazette",
      "text": "Charter registry enters the Holdfast generational claims. \"Recognised, taxable, defensible,\" says the Commissioner.",
      "severity": 2
    },
    {
      "id": "cb.hale_deal.1",
      "kind": "callback",
      "flag": "hale_deal",
      "delayDays": [10, 20],
      "condition": "haleDealStands",
      "channel": "wire",
      "source": "candleRelay",
      "text": "The registry letters came. We read them out at the Candle. Nobody cheered. We note it.",
      "severity": 1
    },
    {
      "id": "cb.hale_deal.2",
      "kind": "callback",
      "flag": "hale_deal",
      "delayDays": [15, 30],
      "condition": "haleDealStands",
      "channel": "comms",
      "speaker": "hale",
      "text": "The registry closed its quarter. The claims are on the board. I keep my word. I'd like to think you keep yours."
    },
    {
      "id": "echo.hale_refused",
      "kind": "echo",
      "flag": "hale_refused",
      "delayDays": 1,
      "channel": "wire",
      "source": "authorityGazette",
      "text": "Commissioner's office declines comment on registry queries.",
      "severity": 1
    },
    {
      "id": "cb.hale_refused.1",
      "kind": "callback",
      "flag": "hale_refused",
      "delayDays": [10, 20],
      "channel": "comms",
      "speaker": "hale",
      "text": "The Holdfast will wait another quarter. They're good at waiting. I hope it was worth it to you."
    },
    {
      "id": "echo.hale_knows",
      "kind": "echo",
      "flag": "hale_knows",
      "delayDays": 1,
      "channel": "log",
      "text": "REGISTRY DIGEST · weekly · item 14\nRecords access, sealed stacks, CY10. Copied: Commissioner's office. Initialled: H."
    },
    {
      "id": "cb.hale_knows.1",
      "kind": "callback",
      "flag": "hale_knows",
      "delayDays": [10, 20],
      "channel": "wire",
      "source": "authorityGazette",
      "text": "Registry fees reviewed for \"irregular\" filers. The Charter Office cites workload.",
      "severity": 1
    },
    {
      "id": "echo.duarte_exposed",
      "kind": "echo",
      "flag": "duarte_exposed",
      "delayDays": 1,
      "channel": "wire",
      "source": "authorityGazette",
      "text": "Registry clerk reassigned to the Lease Office night desk.",
      "severity": 1
    },
    {
      "id": "cb.duarte_exposed.1",
      "kind": "callback",
      "flag": "duarte_exposed",
      "delayDays": [10, 20],
      "channel": "comms",
      "speaker": "duarte",
      "text": "Night desk. Fewer stamps. If I lean, I can see the Candle from the window."
    },
    {
      "id": "echo.hale_deal_voided",
      "kind": "echo",
      "flag": "hale_deal_voided",
      "delayDays": 1,
      "channel": "wire",
      "source": "authorityGazette",
      "text": "Charter Office places charters issued this quarter under review.",
      "severity": 2
    },
    {
      "id": "cb.hale_deal_voided.1",
      "kind": "callback",
      "flag": "hale_deal_voided",
      "delayDays": [10, 20],
      "channel": "wire",
      "source": "candleRelay",
      "text": "The registry wants our claims argued again. We have the scrubber logs. We had them the first time.",
      "severity": 1
    },
    {
      "id": "echo.claim_assisted_2",
      "kind": "echo",
      "flag": "claim_assisted_2",
      "delayDays": 1,
      "channel": "log",
      "text": "MUTUAL ARCHIVE · decode ledger\nRequest re-filed by a second hand. Fee waived."
    },
    {
      "id": "cb.claim_assisted_2.1",
      "kind": "callback",
      "flag": "claim_assisted_2",
      "delayDays": [10, 20],
      "channel": "comms",
      "speaker": "kell",
      "text": "That one was mine. The next one's yours."
    },
    {
      "id": "echo.claim_assisted_3",
      "kind": "echo",
      "flag": "claim_assisted_3",
      "delayDays": 1,
      "channel": "log",
      "text": "MUTUAL ARCHIVE · decode ledger\nRequest countersigned by a second hand. Fee waived."
    },
    {
      "id": "cb.claim_assisted_3.1",
      "kind": "callback",
      "flag": "claim_assisted_3",
      "delayDays": [10, 20],
      "channel": "comms",
      "speaker": "kell",
      "text": "I filled in the gaps. Don't get used to it."
    },
    {
      "id": "echo.claim_assisted_4",
      "kind": "echo",
      "flag": "claim_assisted_4",
      "delayDays": 1,
      "channel": "log",
      "text": "MUTUAL ARCHIVE · decode ledger\nRequest countersigned. Second hand: Holdfast registry. Fee waived."
    },
    {
      "id": "cb.claim_assisted_4.1",
      "kind": "callback",
      "flag": "claim_assisted_4",
      "delayDays": [10, 20],
      "channel": "comms",
      "speaker": "kell",
      "text": "You were close. Close isn't a hearing."
    },
    {
      "id": "echo.claim_assisted_5",
      "kind": "echo",
      "flag": "claim_assisted_5",
      "delayDays": 1,
      "channel": "log",
      "text": "MUTUAL ARCHIVE · decode ledger\nRequest countersigned. Second hand withheld. Fee waived."
    },
    {
      "id": "cb.claim_assisted_5.1",
      "kind": "callback",
      "flag": "claim_assisted_5",
      "delayDays": [10, 20],
      "channel": "comms",
      "speaker": "kell",
      "text": "The last of it's yours now. I'm done carrying it."
    },
    {
      "id": "echo.first_core_logged",
      "kind": "echo",
      "flag": "first_core_logged",
      "delayDays": 1,
      "channel": "wire",
      "source": "mutualBulletin",
      "text": "Data cores off old wrecks fetch a decode fee at the Mutual archive. Bring them in sealed.",
      "severity": 1
    },
    {
      "id": "cb.first_core_logged.1",
      "kind": "callback",
      "flag": "first_core_logged",
      "delayDays": [5, 10],
      "channel": "comms",
      "speaker": "mutualArchivist",
      "text": "You brought in a core. Most pilots sell them for the casing. Bring the next one to me first."
    },
    {
      "id": "echo.first_ruin_logged",
      "kind": "echo",
      "flag": "first_ruin_logged",
      "delayDays": 1,
      "channel": "wire",
      "source": "candleRelay",
      "text": "An independent ship was seen at the old ring ruins. Leave the doors as you found them.",
      "severity": 1
    },
    {
      "id": "cb.first_ruin_logged.1",
      "kind": "callback",
      "flag": "first_ruin_logged",
      "delayDays": [10, 20],
      "channel": "comms",
      "speaker": "kell",
      "text": "You were out at the ruins. My aunt's on one of those boards. Don't ask me which."
    },
    {
      "id": "echo.harrow_hook_posted",
      "kind": "echo",
      "flag": "harrow_hook_posted",
      "delayDays": 1,
      "channel": "wire",
      "source": "mutualBulletin",
      "text": "Harrow approach: convoy wreck cores still unclaimed. The Mutual pays the decode.",
      "severity": 1
    },
    {
      "id": "cb.harrow_hook_posted.1",
      "kind": "callback",
      "flag": "harrow_hook_posted",
      "delayDays": [10, 20],
      "channel": "wire",
      "source": "candleRelay",
      "text": "Lease pilots salvaging the Harrow approach are asked to keep clear of the beacon field.",
      "severity": 1
    },
    {
      "id": "echo.kell_nudge_1",
      "kind": "echo",
      "flag": "kell_nudge_1",
      "delayDays": 1,
      "channel": "wire",
      "source": "candleRelay",
      "text": "Gate held forty minutes. Ours released last. We note it.",
      "severity": 1
    },
    {
      "id": "echo.kell_nudge_2",
      "kind": "echo",
      "flag": "kell_nudge_2",
      "delayDays": 1,
      "channel": "wire",
      "source": "candleRelay",
      "text": "Gate held two hours. Ours released last. We note it.",
      "severity": 1
    },
    {
      "id": "echo.kell_nudge_3",
      "kind": "echo",
      "flag": "kell_nudge_3",
      "delayDays": 1,
      "channel": "wire",
      "source": "candleRelay",
      "text": "Gate held nine hours. Ours released last. The Candle is set to nine.",
      "severity": 1
    },
    {
      "id": "echo.kell_nudge_4",
      "kind": "echo",
      "flag": "kell_nudge_4",
      "delayDays": 1,
      "channel": "wire",
      "source": "candleRelay",
      "text": "Gate held again. The book has a new page.",
      "severity": 1
    },
    {
      "id": "echo.authority_exposed",
      "kind": "echo",
      "flag": "authority_exposed",
      "delayDays": 1,
      "channel": "wire",
      "source": "authorityGazette",
      "text": "Charter hearing enters Settlement minute 50-A into the record.",
      "severity": 3
    },
    {
      "id": "cb.authority_exposed.1",
      "kind": "callback",
      "flag": "authority_exposed",
      "delayDays": [10, 20],
      "channel": "wire",
      "source": "tethysComms",
      "text": "Voss retires on full pension. Tethys thanks her for fifty years of service.",
      "severity": 2
    },
    {
      "id": "cb.authority_exposed.2",
      "kind": "callback",
      "flag": "authority_exposed",
      "delayDays": [15, 30],
      "channel": "comms",
      "speaker": "duarte",
      "text": "They opened the pending box. My grandmother's claim is on my desk. I still can't stamp it. Conflict of interest."
    },
    {
      "id": "echo.voss_blackmailed",
      "kind": "echo",
      "flag": "voss_blackmailed",
      "delayDays": 1,
      "channel": "log",
      "text": "TETHYS · TREASURY · standing order\nPayee: your account. Memo: consultancy. Review: none."
    },
    {
      "id": "cb.voss_blackmailed.1",
      "kind": "callback",
      "flag": "voss_blackmailed",
      "delayDays": [15, 30],
      "condition": "stillBlackmail",
      "channel": "comms",
      "speaker": "voss",
      "text": "Some contractors from Varro will be passing your way. They aren't mine. I'd just like to see what you do."
    },
    {
      "id": "echo.guardian_joined",
      "kind": "echo",
      "flag": "guardian_joined",
      "delayDays": 1,
      "channel": "wire",
      "source": "authorityGazette",
      "text": "Authority posts warrant for independent pilot flying with raiders.",
      "severity": 2
    },
    {
      "id": "cb.guardian_joined.1",
      "kind": "callback",
      "flag": "guardian_joined",
      "delayDays": [10, 20],
      "condition": "reyesAlive",
      "channel": "comms",
      "speaker": "reyes",
      "text": "First raid's on the board. It's a lease barge. You knew that when you came."
    },
    {
      "id": "echo.stipend_known",
      "kind": "echo",
      "flag": "stipend_known",
      "delayDays": 1,
      "channel": "wire",
      "source": "authorityGazette",
      "text": "Hearing told the evidence came from a pilot on a Tethys stipend.",
      "severity": 2
    },
    {
      "id": "cb.stipend_known.1",
      "kind": "callback",
      "flag": "stipend_known",
      "delayDays": [10, 20],
      "channel": "comms",
      "speaker": "kell",
      "text": "Everyone at the Candle knows about the money now. Nobody's said it to me. They say it to the wall."
    },
    {
      "id": "echo.duarte_testifies",
      "kind": "echo",
      "flag": "duarte_testifies",
      "delayDays": 1,
      "channel": "wire",
      "source": "authorityGazette",
      "text": "Registry clerk testifies at the Charter hearing. Cross-examination runs two days.",
      "severity": 2
    },
    {
      "id": "cb.duarte_testifies.1",
      "kind": "callback",
      "flag": "duarte_testifies",
      "delayDays": [10, 20],
      "channel": "comms",
      "speaker": "duarte",
      "text": "They asked me my grandmother's name four times. I said it four times."
    },
    {
      "id": "echo.on_payroll",
      "kind": "echo",
      "flag": "on_payroll",
      "delayDays": 1,
      "channel": "wire",
      "source": "tethysComms",
      "text": "Tethys welcomes independent contractors to its Reach Division roster.",
      "severity": 1
    },
    {
      "id": "cb.on_payroll.1",
      "kind": "callback",
      "flag": "on_payroll",
      "delayDays": [10, 20],
      "channel": "comms",
      "speaker": "kell",
      "text": "They've got you on a roster now. I've got you on one too. Different column."
    },
    {
      "id": "echo.ban_passed",
      "kind": "echo",
      "flag": "ban_passed",
      "delayDays": 1,
      "channel": "wire",
      "source": "authorityGazette",
      "text": "Charter vote passes the tetherstone ban. Carrow cuts to one shift.",
      "severity": 3
    },
    {
      "id": "cb.ban_passed.1",
      "kind": "callback",
      "flag": "ban_passed",
      "delayDays": [15, 30],
      "channel": "wire",
      "source": "tethysComms",
      "text": "Tethys lays off Carrow ring crews \"pending review\". Ring stores report half rations.",
      "severity": 2
    },
    {
      "id": "echo.ban_failed",
      "kind": "echo",
      "flag": "ban_failed",
      "delayDays": 1,
      "channel": "wire",
      "source": "authorityGazette",
      "text": "Tetherstone ban fails at the Charter vote. The chair thanks members for an orderly debate.",
      "severity": 3
    },
    {
      "id": "cb.ban_failed.1",
      "kind": "callback",
      "flag": "ban_failed",
      "delayDays": [10, 20],
      "channel": "wire",
      "source": "tethysComms",
      "text": "Carrow adds a fourth shift.",
      "severity": 2
    },
    {
      "id": "echo.harrow_surveyed",
      "kind": "echo",
      "flag": "harrow_surveyed",
      "delayDays": 1,
      "channel": "wire",
      "source": "candleRelay",
      "text": "Someone ran a survey pass on the Harrow. The Harrow isn't for sale.",
      "severity": 1
    },
    {
      "id": "cb.harrow_surveyed.1",
      "kind": "callback",
      "flag": "harrow_surveyed",
      "delayDays": [5, 10],
      "channel": "comms",
      "speaker": "kell",
      "text": "The Harrow's ours. It isn't on any registry and it doesn't need to be. Fly past it if you like."
    },
    {
      "id": "echo.candle_run_offered",
      "kind": "echo",
      "flag": "candle_run_offered",
      "delayDays": 1,
      "channel": "wire",
      "source": "candleRelay",
      "text": "The Candle needs fuel cells. Holdfast pilots, and anyone else who flies past.",
      "severity": 1
    },
    {
      "id": "cb.candle_run_offered.1",
      "kind": "callback",
      "flag": "candle_run_offered",
      "delayDays": [10, 20],
      "channel": "comms",
      "speaker": "kell",
      "text": "The Candle's still lit. Somebody has to keep it that way. It doesn't have to be you."
    },
    {
      "id": "echo.finale_commit.expose",
      "kind": "echo",
      "flag": "finaleCommit",
      "delayDays": 1,
      "condition": "toExpose",
      "channel": "wire",
      "source": "authorityGazette",
      "text": "Charter Hub schedules a hearing on a tetherstone ban.",
      "severity": 2
    },
    {
      "id": "echo.finale_commit.sell",
      "kind": "echo",
      "flag": "finaleCommit",
      "delayDays": 1,
      "condition": "toSell",
      "channel": "wire",
      "source": "mutualBulletin",
      "text": "Meridian Counsel files a grievance against Tethys. Sources say the file was bought.",
      "severity": 2
    },
    {
      "id": "cb.finale_commit.sell",
      "kind": "callback",
      "flag": "finaleCommit",
      "delayDays": [10, 20],
      "condition": "toSell",
      "channel": "comms",
      "speaker": "meridianDesk",
      "text": "Payment cleared. We'll call if we need you again. We usually don't."
    },
    {
      "id": "echo.ladder_move.lawsuit",
      "kind": "echo",
      "flag": "ladderMove",
      "delayDays": 1,
      "condition": "leftBlackmail",
      "channel": "wire",
      "source": "tethysComms",
      "text": "Tethys sues former contractor for breach.",
      "severity": 2
    },
    {
      "id": "echo.ladder_move.raider_sponsor",
      "kind": "echo",
      "flag": "ladderMove",
      "delayDays": 1,
      "condition": "exposeAndGuardians",
      "channel": "wire",
      "source": "authorityGazette",
      "text": "The ban's sponsor flies with raiders.",
      "severity": 2
    },
    {
      "id": "echo.ladder_move.new_pilot",
      "kind": "echo",
      "flag": "ladderMove",
      "delayDays": 1,
      "condition": "toGuardians",
      "channel": "wire",
      "source": "candleRelay",
      "text": "The cell has a new pilot. Yellow paint, cream band. We've written it in the book.",
      "severity": 1
    },
    {
      "id": "echo.ladder_move.sell",
      "kind": "echo",
      "flag": "ladderMove",
      "delayDays": 1,
      "condition": "toSell",
      "channel": "wire",
      "source": "mutualBulletin",
      "text": "Meridian's legal department buys a Tethys file. The Mutual would like to know who sold it.",
      "severity": 2
    },
    {
      "id": "echo.restart_lit",
      "kind": "echo",
      "flag": "restartLit",
      "delayDays": 1,
      "channel": "wire",
      "source": "mutualBulletin",
      "text": "{station} lights up after fifty years.",
      "severity": 1
    },
    {
      "id": "echo.handover_holdfast",
      "kind": "echo",
      "flag": "handoverHoldfast",
      "delayDays": 1,
      "channel": "wire",
      "source": "candleRelay",
      "text": "The {family} household moves into {station}. The air plant runs. We note it.",
      "severity": 1
    },
    {
      "id": "cb.handover_holdfast.1",
      "kind": "callback",
      "flag": "handoverHoldfast",
      "delayDays": [15, 30],
      "channel": "log",
      "text": "MESSAGE · relayed by the Candle\nFrom the {family} household, {station}.\nThe scrubbers are new. The rota on the galley wall is my grandmother's. We kept it. Thank you for the power."
    },
    {
      "id": "echo.marked_self_restart",
      "kind": "echo",
      "flag": "markedSelfRestart",
      "delayDays": 1,
      "channel": "wire",
      "source": "candleRelay",
      "text": "{station} is lit again. The {family} household filed on it in the dark years. The registry has no record of it.",
      "severity": 1
    },
    {
      "id": "cb.marked_self_restart.1",
      "kind": "callback",
      "flag": "markedSelfRestart",
      "delayDays": [1, 2],
      "channel": "comms",
      "speaker": "kell",
      "text": "That station's a {family} station. You knew that. It's legal. I'm only saying the name."
    },
    {
      "id": "cb.marked_self_restart.2",
      "kind": "callback",
      "flag": "markedSelfRestart",
      "delayDays": [15, 30],
      "channel": "comms",
      "speaker": "stationControl",
      "text": "A Holdfast pilot asks to dock at {station}. She'd like to see her grandmother's quarters on ring two. She says she won't touch anything."
    },
    {
      "id": "echo.handover_tethys_vein",
      "kind": "echo",
      "flag": "handoverTethysVein",
      "delayDays": 1,
      "channel": "wire",
      "source": "tethysComms",
      "text": "Tethys commissions a fracture rig at {station}, \"with thanks to the independent pilot who restored it.\"",
      "severity": 2
    },
    {
      "id": "cb.handover_tethys_vein.1",
      "kind": "callback",
      "flag": "handoverTethysVein",
      "delayDays": [5, 10],
      "channel": "comms",
      "speaker": "kell",
      "text": "You handed a Rush station to Tethys. They've put a rig on it. You knew that too."
    },
    {
      "id": "echo.okafor_lab_restart",
      "kind": "echo",
      "flag": "okaforLabRestart",
      "delayDays": 1,
      "channel": "wire",
      "source": "mutualBulletin",
      "text": "Old Carrow research lab restarted as a clinic.",
      "severity": 1
    },
    {
      "id": "cb.okafor_lab_restart.1",
      "kind": "callback",
      "flag": "okaforLabRestart",
      "delayDays": [5, 15],
      "condition": "okaforSafe",
      "channel": "comms",
      "speaker": "okafor",
      "text": "Bay four's a treatment room now. That's a better use for it than mine was."
    }
  ]
}
